import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../StyledComponents';
import { Title } from './HomePage/HomepageSectionOne';
import BackgroundImage from 'gatsby-background-image';
import { StaticQuery, graphql } from 'gatsby';
const BottomSection = styled(BackgroundImage)`
  min-height: 250px;
  padding: 3rem 0rem;
  background-color: #151e31;
  background-size: cover;
  display: grid;
  @media (max-width: 520px) {
    height: fit-content;
  }
`;
const BottomContent = styled.div`
  display: grid;
  align-self: center;
  justify-content: center;
`;
const BottomButton = styled(BlueButton)`
  /* border-radius: 12px; */
  background-color: #725cbd;
`;
const BlueButtonWrapper = styled.div`
  justify-self: center;
  margin-top: 1rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-bottom: 0;
  }
`;

const BannerTitle = styled(Title)`
  font-size: 44px;
  font-weight: 500;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
`;

const BannerDescription = styled(Title)`
  max-width: 520px;
  margin-bottom: 0rem;
  text-align: center;
  font-size: 28px;
  line-height: 1.5;
  color: #fff;
`;

export const BottomBanner = ({
  title,
  description,
  buttonText,
  link,
  buttonAction,
}: {
  title?: string;
  description?: string;
  buttonText: string;
  link?: string;
  buttonAction?: any;
}) => (
  <StaticQuery
    query={graphql`
      query {
        background: file(
          relativePath: { eq: "v2/homepage/website_banner.png" }
        ) {
          childImageSharp {
            fluid(quality: 85) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    `}
    render={(data) => (
      <BottomSection fluid={data.background.childImageSharp.fluid}>
        <BottomContent>
          {title && <BannerTitle>{title}</BannerTitle>}
          {description && <BannerDescription>{description}</BannerDescription>}
          <BlueButtonWrapper>
            <BottomButton
              id={`banner_${buttonText.replace(/ /g, '_')}`}
              onClick={
                buttonAction
                  ? buttonAction
                  : () => (window.location.href = link!)
              }
            >
              {' '}
              {buttonText}
            </BottomButton>
          </BlueButtonWrapper>
        </BottomContent>
      </BottomSection>
    )}
  />
);
